export default "__VITE_ASSET__a000446f__"